import { SupportDashboardT } from 'routes/Support/models';
import { HomePageMetadata } from './types';

export const dashboardSlugToUrl = (slug: string): string =>
    `/dashboard/${slug}`;

export const getCurrentHomePage = (
    homePageUrl: string | null | undefined,
    bindDashboards: SupportDashboardT[],
): HomePageMetadata => {
    if (!homePageUrl) {
        return {
            status: 'success',
            isDashboard: false,
            homePageUrl: null,
        };
    }
    const dashboardHomePage = bindDashboards.find(
        (dashboard) => dashboardSlugToUrl(dashboard.slug) === homePageUrl,
    );
    if (dashboardHomePage) {
        return {
            homePageUrl,
            status: 'success',
            homePageTitle: dashboardHomePage.title,
            isDashboard: true,
        };
    }
    return {
        status: 'unknown',
        isDashboard: false,
        homePageUrl: null,
    };
};
